var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('header',[_c('WebHeader',{attrs:{"msg":"WebHeader"}}),_c('SettingsHeader',{attrs:{"msg":"SettingsHeader"}})],1),_c('UserData',{attrs:{"type":"web"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }